module.exports = __webpack_public_path__ + "static/img/lightbulb.884db30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lightbulb.png
// module id = yABz
// module chunks = 1